"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var datePickerCard_styles_1 = require("../datePickerCard.styles");
var check_icon_1 = require("../../../../svg/check.icon");
var core_components_1 = require("@securityproducts/core-components");
var datePickerCard_i18n_1 = require("../datePickerCard.i18n");
exports.DatePickerRange = function (props) {
    var strings = core_components_1.useLocalisation(datePickerCard_i18n_1.datePickerCardTranslations, props.language);
    var isActive = props.currentRange === props.range.label;
    var className = props.className ? props.className : datePickerCard_styles_1.label;
    return (react_1.default.createElement("div", { className: className + " options", "data-qa": "date-range", "data-qa-is-active": isActive.toString(), "data-qa-date-range": props.label.replace(/\s/g, ""), onClick: props.onClick },
        props.label,
        props.comparison && (react_1.default.createElement("div", { className: "" + datePickerCard_styles_1.labelSecondary }, strings[props.comparison])),
        isActive ? react_1.default.createElement(check_icon_1.Check, null) : null));
};
